import React from "react";
import { useButtonInlineStore } from "../../../stores/use-button-inline-store";
import {
  ButtonEditorContainer,
  ButtonEditorSkeleton,
  ButtonEditorSkeletonContainer,
  Flex,
} from "../../button-block/components/editor/styles";
import { urlValidator } from "../../../helpers/validators";
import { ButtonWidget } from "@caelor/ui";

const ButtonInlineEditor = () => {
  const { data, setData } = useButtonInlineStore((state) => ({
    data: state.data,
    setData: state.setData,
  }));

  return (
    <ButtonEditorContainer>
      <ButtonEditorSkeletonContainer>
        <ButtonEditorSkeleton />
        <ButtonEditorSkeletonContainer gap="8px">
          {Array.from({ length: 3 }).map(() => (
            <ButtonEditorSkeleton height="16px" />
          ))}
          <Flex>
            <ButtonEditorSkeleton width="240px" height="16px" />
            <ButtonWidget
              data={data}
              isEditable={true}
              onClick={() => {
                if (
                  urlValidator({ url: data.url?.link, protocols: ["https:"] })
                )
                  window.open(data.url?.link, data.newTab ? "_blank" : "_top");
              }}
              setData={setData}
            />
          </Flex>
        </ButtonEditorSkeletonContainer>
      </ButtonEditorSkeletonContainer>
    </ButtonEditorContainer>
  );
};

export default ButtonInlineEditor;
